export default "__VITE_ASSET__CR2SlcHf__"